import { render, staticRenderFns } from "./play_control.vue?vue&type=template&id=88230236&scoped=true&"
import script from "./play_control.vue?vue&type=script&lang=js&"
export * from "./play_control.vue?vue&type=script&lang=js&"
import style0 from "./play_control.vue?vue&type=style&index=0&id=88230236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88230236",
  null
  
)

export default component.exports